import { FC } from 'react'
import cn from 'classnames'
import ReactModal from 'react-modal'

import { useActionModalContext } from './ActionModalContext'
import ConsolePetitionActionForm from './ActionForm'

import styles from './ConfirmationModal.module.scss'

import { ReactComponent as IconClose } from 'images/icons/close.svg'

const ConsolePetitionConfirmationModal: FC = () => {
  const { actionModal, setActionModal } = useActionModalContext()

  if (!actionModal) {
    return null
  }

  const { action, draft } = actionModal

  const handleClose = () => setActionModal(null)

  return (
    <ReactModal
      isOpen={!!actionModal.draft}
      className={cn(styles.modal)}
      shouldFocusAfterRender={true}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={handleClose}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <IconClose className={styles.closeIcon} onClick={handleClose} />
          <div className={styles.sectionName}>Console Petition Review</div>
          <div className={styles.title}>{draft.data.title}</div>
          <div className={styles.info}>
            Action: <strong>{action}</strong>
          </div>
        </div>
        <ConsolePetitionActionForm action={action} draftId={draft.id} handleClose={handleClose} />
      </div>
    </ReactModal>
  )
}

export default ConsolePetitionConfirmationModal
